import CulpritEntryTabIcon from '@/common/assets/icons/culpritEntryTab.svg?react';
import CardButton from '@/common/components/cardButton/CardButton';
import useModal from '@/common/hooks/useModal';
import { Box } from 'styled-system/jsx';
import CulpritInformationModal from '@/modules/FileDetail/components/fileInformation/modals/CulpritInformationModal/CulpritInformationModal.tsx';
import { CulpritInformationCardProps } from '@/modules/FileDetail/components/fileInformation/entryTabs/CulpritInformationCard/CulpritInformationCard.types.ts';

const CulpritInformationCard = ({ title }: CulpritInformationCardProps) => {
  const { open, openModal, closeModal } = useModal();

  const renderIcon = () => {
    return <CulpritEntryTabIcon />;
  };

  return (
    <>
      <Box onClick={openModal} mb="16px">
        <CardButton hasArrow renderIcon={renderIcon} title={title} />
      </Box>
      <CulpritInformationModal closeModal={closeModal} open={open} />
    </>
  );
};
export default CulpritInformationCard;
